import React, {Component} from 'react'
import {Typeahead} from "react-bootstrap-typeahead";
import nationalities from 'utils/Nationality/nationalities';
import {connect} from "react-redux";

class NationalityTypeahead extends Component {

    constructor(props) {
        super(props);
        this.state = {            
            multiple: false
        };
    }

    handleChange = (nationality) => {        
        if(nationality && nationality.length > 0){
            console.log("nationality", nationality[0].name);
            this.props.handleChange(nationality[0].name);
        }else{
            this.props.handleChange("");
        }
    }

    render() {        
        return (
            <Typeahead
                {...this.state}                
                labelKey="name"
                options= {nationalities}
                onChange={(nationality) => this.handleChange(nationality)}
                placeholder="Escoge una nacionalidad..."
            />
        )
    }
}
export default NationalityTypeahead


// WEBPACK FOOTER //
// ./src/components/Typeaheads/NationalityTypeahead.jsx